import { useSalonManagerContext } from '@admin/components/templates/SalonManager/context'
import Table from '@modules/Table'
import React from 'react'
import columns from './config/columns'
import usePaymentsTableOptions from './hooks/usePaymentsTableOptions'

export default function SalonPaymentsPage() {
    const { salon } = useSalonManagerContext()
    const payments = salon.api.payments.use(`admin:salon:${salon.state.id}:payments`)
    const options = usePaymentsTableOptions()

    if (!payments.data) 
        return null

    return <Table data={payments.data} columns={columns} options={options} />
}